import CryptoJS from 'crypto-js'

export interface ProjectTableToEncryptData {
  jwt: string
  snowflakeTableId: string
  organizationOutputId: string
}

const encryptProjectTableData = (data: ProjectTableToEncryptData): string => {
  const jsonData = JSON.stringify(data)
  const secretKey = import.meta.env.VITE_APP_SECRET

  const iv = CryptoJS.lib.WordArray.random(16)

  const encrypted = CryptoJS.AES.encrypt(jsonData, CryptoJS.enc.Utf8.parse(secretKey), {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })

  const result = iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64)

  return encodeURIComponent(result)
}

export { encryptProjectTableData }
